import { useRtoasterRecommendWithCache } from "@/hooks";
import RtRecommendList from "@/components/Rtoaster/RtRecommendList";
import config from "@/lib/config";

/**
 * TvShowRecommend.
 *
 * titleページ用のRtoasterレコメンド
 *
 * @returns {React.ReactElement}
 */
export default function TvShowRecommend() {
  const elementIds = [
    config.rtoasterElementId.title.related,
    config.rtoasterElementId.title.recommend,
  ];
  const { loading } = useRtoasterRecommendWithCache(elementIds);

  if (loading) return null;

  return (
    <>
      <RtRecommendList
        header={{ text: "関連作品" }}
        elementId={config.rtoasterElementId.title.related}
      />
      <RtRecommendList
        header={{ text: "あなたにおすすめの作品" }}
        elementId={config.rtoasterElementId.title.recommend}
      />
    </>
  );
}
